/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'classnames';
import FilterItem from './Item';
import { getIsDefaultFilterItems } from './utils';
import classes from './FilterBar.module.scss';
import T from 'i18n-react';

const FilterBar = ({ items, onApply, onReset, onFilterReset, className }) => {
  const isDefaultFilter = getIsDefaultFilterItems(items);

  return (
    <div className={cn(classes.wrapper, className)}>
      <ul>
        {items.map((item) => {
          return (
            <FilterItem
              key={item.key}
              item={item}
              defaultChecks={item.dropdown?.defaultChecks || []}
              defaultDate={item.dropdown?.defaultDate || null}
              onApply={(val, dateVal) => {
                onApply && onApply(item, val, dateVal);
              }}
              onReset={(val, dateVal) => {
                onReset && onReset(item, val, dateVal);
              }}
            />
          );
        })}
        <FilterItem isReset isDisabled={isDefaultFilter}>
          <span className={classes.label} onClick={isDefaultFilter ? undefined : onFilterReset}>
            {T.translate('general.reset')}
          </span>
        </FilterItem>
      </ul>
    </div>
  );
};

export default FilterBar;
